import axios from "axios";


const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
axiosInstance.interceptors.response.use(
  (response) => {
    if (!response.data?.status && response.data?.errorMessage === "Session expired") {
      async function postData(url = "", data = {}) {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
        return response.json();
      };
      postData(`${getEnvUrl()}api/user/onlineLogout`, {
        deviceID: localStorage.getItem("deviceID"),
      }).then((data) => {

        // 🔥 Trigger toast event
        window.dispatchEvent(
          new CustomEvent("sessionExpired", {
            detail: "Session expired. Please log in again.",
          })
        );

        localStorage.removeItem("token");

        // ⏳ Delay reload so toast is visible
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
    }
    return response;
  },
  (error) => {
    const status = error.status;
    if (status === 401) {
      //dispatch action logout
      if (JSON.parse(localStorage.getItem("token"))) {
        localStorage.removeItem("token");
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export const getEnvUrl = () => {
  return process.env.REACT_APP_API_CMS + "api/";
};

export const getGamePlayUrl = () => {
  return process.env.REACT_APP_API_CMS
};

axiosInstance.defaults.baseURL = getEnvUrl();

export default axiosInstance;
